module.exports = __webpack_public_path__ + "img/ma_banner.cf385d9e.jpg";